import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";
import OrderSummary from "../../../Components/MiniStore/CartComponents/OrderSummary";
import { CART_LIST } from "../../../utilities/constants";
import CartItem from "./CartItem";
import { CartContext } from "../../../contexts/MiniStore/CartContext";
import { useNavigate } from "react-router-dom";

const MsCart = () => {
  const { theme } = useContext(MiniStoreThemeContext);
  const { cart, updateQuantity, removeFromCart, cartLoading } =
    useContext(CartContext);
  const navigate = useNavigate();

  const getFlexValue = (name) => {
    const flexValues = {
      name: "40%",
      lst_price: "10%",
      qty: "10%",
      total: "10%",
      delete_icon: "5%",
    };
    return flexValues[name] || "10%";
  };

  useEffect(() => {
    if (!cartLoading && cart.length === 0) {
      navigate("/mini-store/shop", { replace: true });
    }
  }, [cartLoading, cart, navigate]);

  return (
    <CartWrapper>
      <CartTitle>Your Cart</CartTitle>
      <CartInnerWrapper>
        <CartList theme={theme}>
          {/* Header */}
          <HeaderCartList>
            {CART_LIST.map((item, index) => (
              <CartColumn
                theme={theme}
                key={index}
                flex={getFlexValue(item.name)}
              >
                {item.title}
              </CartColumn>
            ))}
          </HeaderCartList>

          {/* Cart Items */}
          {cart.map((item, index) => (
            <CartItem
              key={index}
              item={item}
              id={item.id}
              quantity={item.quantity}
              theme={theme}
              removeFromCart={removeFromCart}
              onQuantityChange={(id, change) =>
                updateQuantity({
                  productId: id,
                  qtyChange: change,
                })
              }
            />
          ))}
        </CartList>
        <OrderSummary theme={theme} />
      </CartInnerWrapper>
    </CartWrapper>
  );
};

export default MsCart;

const CartWrapper = styled.div`
  font-family: Outfit, sans-serif;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const CartTitle = styled.div`
  font-family: Outfit, sans-serif;
  font-size: 28px;
  font-weight: 600;
  line-height: 29px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0px 60px 0px;
`;
const CartInnerWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const CartList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(70% - 10px);
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  padding: 1.5rem;
  overflow-y: auto;
  overflow-x: auto;
  max-height: 456px;
`;
const HeaderCartList = styled.div`
  display: flex;
  width: 100%;
  min-width: fit-content;
  font-weight: bold;
  padding: 10px;
  border-bottom: 2px solid #9c9a9a;
`;

const CartColumn = styled.div`
  flex: ${({ flex }) => flex};
  padding: 5px;
  text-align: left;
  font-family: Outfit, sans-serif;
  // background: #fff;
  font-weight: 500;
  font-size: 20px;
  line-height: 15px;
  color: ${({ theme }) => theme.primaryColor.primary};
`;
